import { curry } from 'lodash-es';

export const map = curry((fn, list) => (list || []).map(fn));
